<!-- The .css file stays — admin and morpheus legacy bundles import it directly.
     {@see PChipStyles.vue} -->

<template />

<style lang="postcss">
@import "@/other/pro/s-company-badges/sCompanyBadge.css";
</style>
